import { Component, Input, Output, OnChanges, AfterViewInit, SimpleChanges, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { ChartConfigBase } from '../../models/chart-config-base';
import { HighChartDataBase } from '../../models/high-chart-data-base';
import { LocalDataSource, Angular2SmartTableModule } from 'angular2-smart-table';
import { AsyncPipe } from '@angular/common';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'chart-show-detailed-table',
    styleUrls: ['../chart-show-table/chart-show-table.scss'],
    templateUrl: 'chart-show-detailed-table.html',
    host: { 'cid': 'ChartShowDetail' },
    imports: [Angular2SmartTableModule, AsyncPipe, TranslatePipe]
})
export class ChartShowDetailedTableComponent implements OnChanges {
    @Input() chartData: HighChartDataBase;
    @Output() getExcel = new EventEmitter();
    @Output() isLoading: EventEmitter<boolean> = new EventEmitter();

    public settings = new BehaviorSubject<any>({});
    public data = new BehaviorSubject<any[]>([]);
    public source: LocalDataSource;

    constructor(
        private ref: ChangeDetectorRef,
        private translate: TranslateService )
    {
        this.source = new LocalDataSource();
        this.data.subscribe(data => this.source.load(data));  // laddar om ng2-smart-table med ny data
    }

    ngOnChanges() {
        this.isLoading.emit(true); 

        let settings = this.setSettings();
        this.settings.next(settings);
        let data = this.setData();
        this.data.next(data);

        setTimeout(() => {
            // ng2-smart-table behöver en digest för att rendera färdigt.
            this.ref.detectChanges();
            this.isLoading.emit(false);
        });
    }

    private setSettings() {
        let that = this;
        let settings = {};
        let columns = {};
        settings["hideSubHeader"] = true;
        settings["noDataMessage"] = this.translate.instant('xml-report.table.no-data');
        settings["pager"] = { perPage: 100 };
        settings["actions"] = {
            add: false,
            edit: false,
            delete: false,
            sort: false //PGA konvertering & formatering ej funkar så bra...!
        };
        let i = 1;
        this.chartData.detailedTable.columns.forEach((column) => {
            columns["Value"+i] = { 
                title: column,
                type: 'html',
                valuePrepareFunction: (cell, row) => {
                    let colorClass, alignmentClass = "";
                    let dataArr = that.data.getValue();
                    for (var i = 0; i < that.chartData.detailedTable.rows.length; i++) {
                        let tableRowData: string[] = that.chartData.detailedTable.rows[i];
                        let tableRowColors: string[] = that.chartData.detailedTable.colors[i];
                        let tableRowAlignments: string[] = that.chartData.detailedTable.alignments[i];
                        for (var j = 0; j < tableRowData.length; j++) {
                            if (cell == tableRowData[j]) {
                                colorClass = tableRowColors[j];
                                let _align = tableRowAlignments[j].toLowerCase();
                                alignmentClass = "text-" + (_align == "undefined" ? "end" : (_align == "right" ? "end" : _align)); //Bootstrap 5 "text-right"=>"text-end"
                                
                                i = that.chartData.detailedTable.rows.length; //break first loop
                                break;
                            }
                        }
                    }
                    return `<span class="${alignmentClass} ${colorClass}">${cell}</span>`;
                }
            };
            i++;
        });
        settings["columns"] = columns;

        return settings;
    }

    private setData() {
        let rows = [];
        let i = 0;
        this.chartData.detailedTable.rows.forEach((row: string[]) => {
            let rowItem = {};
            let rowIsEmpty = this.rowIsEmpty(row);            
            if (rowIsEmpty === false) {
                let j = 1;
                row.forEach((item) => {
                    rowItem["Value"+j] = this.formatValue(item);
                    j++;
                });
                if (rowItem["Value"+1] != "") {
                    //Lägg till raden om inte första kolumnen är tom
                    rows.push(rowItem);
                }
            }
            i++;
        });
        return rows;
    }

    private rowIsEmpty(row: string[]): boolean {
        let rowIsEmpty = false;
        for(let j = 0; j < row.length; j++) {
            if (row[j].length > 0) {
                rowIsEmpty = false;
                break;
            } 
            else {
                rowIsEmpty = true;
            }
        }
        return rowIsEmpty;
    }

    private formatValue(value) {
        return value;

        /*
         * Sorteringen fungerar halvdant trots konvertering -> Tillsvidare: Visa talen rätt formaterade utan sorteringsfunktion!
         *
        if (value.length == 0 || Number.isNaN(Number(value))) {
            return value;
        } else {
            return Number(
                new Intl.NumberFormat(this.translate.currentLang, { maximumFractionDigits: this.chartData.yAxisDecimals, minimumFractionDigits: this.chartData.yAxisDecimals }) //ex. 'en-US': 10000.54 => 10,000.54
                    .format(value).replace(",", ""));
        }
        */
    }

    public getExcelFile() {
        this.getExcel.emit();
    }
}
